<template>
  <a-select v-model="selectedValue" placeholder="选择线路" show-search :filter-option="filterOption">
    <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
      {{ el.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  props: ['val', 'feild'],
  data() {
    return {
      lineList: [],
      setFirst: false,
      selectedValue: undefined
    }
  },
  watch: {
    selectedValue(val) {
      this.$emit('input', val)
      this.$emit('change', val)
      this.$emit('setVal', { [this.feild]: val })
    },
    val(val) {
      this.selectedValue = val
    }
  },
  mounted() {
    this.getTypeList()
  },
  methods: {
    getTypeList() {
      let params = { current: 1, size: 10000 }
      this.$http.get(`/nhf-core-data/line/list`, { params }).then(res => {
        let { success, data } = res
        if (success) {
          this.typeList = data?.records || []
          this.getLineList()
        }
      })
    },
    reset() {
      this.selectedValue = undefined
    },
    getLineList() {
      let staffId = window.localStorage.getItem('staffId')
      if (!staffId) return
      this.$http.get(`/iot-factory/factorystaffauth/getAnimalIdsInfoByStaffId?StaffId=${staffId}&type=0`).then(data => {
        if (data && data.length > 0) {
          data = data.sort((a, b) => a - b)
          let lineList = this.typeList.filter(el => data.includes(el.id))
          this.lineList = lineList
          if (this.setFirst && !this.selectedValue) {
            this.selectedValue = lineList[0]?.id
            this.$emit('input', this.selectedValue)
            this.$emit('setVal', { [this.feild]: this.selectedValue })
          }
        }
      })
    }
  }
}
</script>
